import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle, linkText, buttonStyle } from '../../../helpers/getEmailStyles';

class AdminListApprove extends React.Component {

	static propTypes = {
		content: PropTypes.shape({
			userMail: PropTypes.string.isRequired,
		}).isRequired
	};

	render() {
		const { content: { hostName, listId, listTitle, logo, siteName } } = this.props;
		const URL = url + `/become-a-host/${listId}/home`;
		const listURL = url + `/rooms/${listId}/preview`;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
				<Body textStyle={textStyle}>
					<div>
						Hola {hostName},
					</div>
					<EmptySpace height={20} />
					<div>
						El administrador ha verificado sus listados <a href={listURL} style={linkText}> {listTitle} </a>. Por favor publique su anuncio para obtener nuevas reservas.
					</div>
					<EmptySpace height={40} />
					<div>
						<a style={buttonStyle} href={URL}>Publicar</a>
					</div>
					<EmptySpace height={40} />
					<EmailSignature siteName={siteName} />
				</Body>
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default AdminListApprove;